import { computed } from 'vue';
import { useStore } from 'vuex';
import useExperimentIds from '@composables/useExperimentIds';
import useDevice from '@modules/discovery/composables/useDevice';

export const CONVO_SEARCH_EXP_1 = '2465-21';
export const CONVO_SEARCH_EXP_2 = '2465-22';
export const CONVO_SEARCH_EXP_3 = '2465-23';

export const ROW_INDEXES = {
  [CONVO_SEARCH_EXP_1]: {
    DESKTOP: 3,
    MEW: 6,
  },
  [CONVO_SEARCH_EXP_2]: {
    DESKTOP: 6,
    MEW: 10,
  },
  [CONVO_SEARCH_EXP_3]: {
    DESKTOP: 6,
    MEW: 10,
  },
};

export default function useConvoSearchExperiment() {
  const { isDesktop } = useDevice();

  const deviceType = isDesktop ? 'DESKTOP' : 'MEW';
  const store = useStore();

  const { experimentIds } = useExperimentIds();

  const convoSearchArms = computed(() => {
    const arms = [CONVO_SEARCH_EXP_1, CONVO_SEARCH_EXP_2, CONVO_SEARCH_EXP_3];
    return arms.map((exp) => ({
      name: exp,
      active: experimentIds.value.includes(exp),
    }));
  });

  const convoSearchEnabled = computed(() => convoSearchArms.value.some((arm) => arm.active));

  const currentExperiment = computed(() => {
    /* istanbul ignore else */
    if (convoSearchEnabled.value) {
      const currentExp = convoSearchArms.value.find((arm) => arm.active);
      return currentExp.name;
    }
    return null;
  });

  const rowIndex = computed(() => {
    /* istanbul ignore else */
    if (convoSearchEnabled.value) {
      const exp = convoSearchArms.value.find((arm) => arm.active).name;
      return ROW_INDEXES[exp][deviceType];
    }
    return null;
  });

  const convoSearchResult = computed(() => store.getters.getConvoSearchResult);
  const hasFollowupQuestion = computed(() => !!convoSearchResult.value?.suggestedAnswers && !!convoSearchResult.value?.followupQuestion);

  return {
    convoSearchEnabled,
    rowIndex,
    convoSearchResult,
    hasFollowupQuestion,
    currentExperiment,
  };
}
